import AdyenCheckout from '@adyen/adyen-web';
import { useRef, useEffect } from 'react';
import { overrideAdyenTranslations, getAdyenCardBrands, styles, RENDER_CONTAINER_ID } from '../components/AdyenCreditCardForm/AdyenCreditCardForm.static.js';
import { normalizeLocaleForAdyen } from '../config/Adyen.static.js';

/**
 * Effect hook over the initialization of the 'securedfields' of AdyenCheckout.
 * The inputs 'encryptedCardNumber', 'encryptedExpiryMonth', 'encryptedExpiryYear' and 'encryptedSecurityCode' will be managed by Adyen once this hook finishes.
 */
const useAdyenSecureFields = (config, supportedCreditCardBrands) => {
    const securedFields = useRef();
    const { adyenEnvironment, locale, t, clientKey, onChange, onFocus, onFieldValid, onBrand, onBinLookup, onFatalError, } = config;
    useEffect(() => {
        async function initialize() {
            try {
                const adyenLocale = normalizeLocaleForAdyen(locale);
                const adyen = await AdyenCheckout({
                    environment: adyenEnvironment,
                    translations: { [adyenLocale]: overrideAdyenTranslations(t) },
                    locale: adyenLocale,
                    clientKey,
                    onChange,
                });
                securedFields.current = adyen.create('securedfields', {
                    type: 'card',
                    brands: getAdyenCardBrands(supportedCreditCardBrands),
                    styles: styles,
                    onBrand,
                    onFieldValid,
                    onFocus,
                    onBinLookup,
                });
                securedFields.current.mount(`#${RENDER_CONTAINER_ID}`);
            }
            catch (error) {
                onFatalError(error, false);
            }
        }
        initialize();
        /**
         * This dependency list needs to be revisted/retested, calling the initialize function more then once will
         * cause Adyen to throw an error
         * We need to investigate:
         *  * In case we need to update the adyen config we need to do something else and not initialize again because it will throw an error
         *  * In case we don't ever need to update the adyen config we should remove this part as it is missleading
         */
    }, [
        supportedCreditCardBrands,
        adyenEnvironment,
        locale,
        clientKey,
        onBrand,
        onFieldValid,
        onChange,
        onFatalError,
    ]);
    return securedFields.current;
};

export { useAdyenSecureFields as default };
//# sourceMappingURL=useAdyenSecureFields.js.map
